<template>
    <div class="flex items-center">
        <div class="relative text-xs leading-none tracking-widest uppercase select-none mr-6" :class="color">
            <span
                class="block transition-all transition-circ"
                :class="hovered ? '-translate-y-full opacity-0' : 'translate-y-0 opacity-100'"
            >
                {{ title }}
            </span>
            <span
                class="absolute inset-0 block opacity-0 transition-all transition-circ"
                :class="hovered ? 'translate-y-0 opacity-75' : 'translate-y-full opacity-0'"
            >
                {{ title }}
            </span>
        </div>

        <!-- π ----
        // :: BUTTONS
        // : ---------------------------------- -->

        <!-- :: Open
        {+} ---------------------------------- -->
        <button
            v-if="action === 'open'"
            @click="$root.openNav = true"
            @mouseover="hovered = true"
            @mouseleave="hovered = false"
            class="cursor-pointer py-4 group"
            aria-label="Open Menu"
        >
            <div
                class="w-10 h-2px bg-shark-200 mb-3 transition-500 transition-transform transform-r group-hover:scale-x-120"
            ></div>
            <div
                class="w-10 h-2px bg-shark-200 transition-500 transition-transform transform-l group-hover:scale-x-120"
            ></div>
        </button>

        <!-- :: Close
        {+} ---------------------------------- -->
        <button
            v-else-if="action === 'close'"
            @click="$root.openNav = false"
            @mouseover="hovered = true"
            @mouseleave="hovered = false"
            class="relative flex w-8 h-8 cursor-pointer py-4 group"
            aria-label="Close Menu"
        >
            <div class="relative w-full h-full -ml-1">
                <div class="absolute inset-0 w-10 h-2px bg-white transition-500 transition-transform rotate-45"></div>
                <div class="absolute inset-0 w-10 h-2px bg-white transition-500 transition-transform -rotate-45"></div>
            </div>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        action: String
    },
    data() {
        return {
            title: 'Menu',
            color: 'text-shark-200',
            hovered: false
        };
    },

    mounted() {
        if (this.action === 'close') {
            this.title = 'Close';
            this.color = 'text-white';
        }
    }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: all 0.32s ease;
}
.fade-enter,
.fade-leave-to {
    @apply opacity-0;
}
</style>
